import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next/enablers';
import {faceRecognitionEnabled} from '@netx/core-recognition-face/enablers/faceRecognitionEnabled';

export const canManagePeople = () => {
	if (!faceRecognitionEnabled()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	return currentUserHasAccess(PermissionName.MANAGE_PEOPLE);
};
